module.exports = __webpack_public_path__ + "static/media/31.f69cbaae.jpg";